import { Plus_Jakarta_Sans } from 'next/font/google';

export const plusJakartaSans = Plus_Jakarta_Sans({
    subsets: ['latin'],
    display: 'swap',
    variable: '--font-jakarta',
});

import '@/styles/globals.scss';
import 'flag-icons/css/flag-icons.min.css';
import { Metadata, Viewport } from 'next';
import NextAuthProvider from '@/components/session-provider';
import { LanguageProvider } from '../contexts/LanguageContext';
import { AIModelsProvider } from '@/contexts/AIModelsProvider';
import { IdPathProvider } from '../contexts/IdPathProvider';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import SmartlookAnalytics from '@/components/SmartlookAnalytics';
import PlausibleAnalytics from '@/components/PlausibleAnalytics';
import { Toaster } from 'react-hot-toast';
import HubMessageBridge from '@/components/hub-message-bridge/hub-message-bridge';



export const viewport: Viewport = {
    width: 'device-width',
    initialScale: 1,
    maximumScale: 1,
    userScalable: false,
};


export default function RootLayout({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {
    return (
        <html lang="en" suppressHydrationWarning>
            <body className="antialiased" style={{ fontFamily: 'var(--font-family-project)' }} suppressHydrationWarning>
                
                <IdPathProvider>
                    <AIModelsProvider>
                        <LanguageProvider>
                            <NextAuthProvider>


                                <GoogleAnalytics />
                                <SmartlookAnalytics />
                                <PlausibleAnalytics />
                                <Toaster position="top-right" />
                                <HubMessageBridge />
                                {children}
                            </NextAuthProvider>
                        </LanguageProvider>
                    </AIModelsProvider>
                </IdPathProvider>
            </body>
        </html>
    );
}
